export default __webpack_public_path__ + "static/Flame_Arrow-6d01fb038dfffee15fdac65628fb54f8.png";